import { render, staticRenderFns } from "./MainStudentManagement.vue?vue&type=template&id=12223d4a&scoped=true"
import script from "./MainStudentManagement.vue?vue&type=script&lang=js"
export * from "./MainStudentManagement.vue?vue&type=script&lang=js"
import style0 from "./MainStudentManagement.vue?vue&type=style&index=0&id=12223d4a&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12223d4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12223d4a')) {
      api.createRecord('12223d4a', component.options)
    } else {
      api.reload('12223d4a', component.options)
    }
    module.hot.accept("./MainStudentManagement.vue?vue&type=template&id=12223d4a&scoped=true", function () {
      api.rerender('12223d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/PsychologicalMonthReport/components/MainStudentManagement.vue"
export default component.exports